module.exports = __webpack_public_path__ + "img/couples_18_V.f5c4453d.webp";